import axios from '@/core/http'

const fetchCities = () => {
  return axios.get('sources/cities/').then(res => res.data)
}

export { fetchCities }
